// src/checker.ts
function isObject(value) {
  return value != null && typeof value === "object";
}

// src/dom.ts
function isElement(node) {
  return node.nodeType === 1 /* ELEMENT_NODE */;
}
function isTextNode(node) {
  return node.nodeType === 3 /* TEXT_NODE */;
}
function isHTMLElement(node) {
  return isElement(node) && node.namespaceURI === "http://www.w3.org/1999/xhtml";
}
function isSVGElement(node) {
  return isElement(node) && node.namespaceURI === "http://www.w3.org/2000/svg";
}
function isMathMLElement(node) {
  return isElement(node) && node.namespaceURI === "http://www.w3.org/1998/Math/MathML";
}
function isDocument(node) {
  return node.nodeType === 9 /* DOCUMENT_NODE */;
}
function isDocumentFragment(node) {
  return node.nodeType === 11 /* DOCUMENT_FRAGMENT_NODE */;
}
function isShadowRoot(node) {
  return isDocumentFragment(node) && "host" in node && isElementLike(node.host);
}
function isNodeLike(value) {
  return isObject(value) && value.nodeType !== void 0;
}
function isElementLike(value) {
  return isObject(value) && value.nodeType === 1 /* ELEMENT_NODE */ && typeof value.nodeName === "string";
}
function isWindowLike(value) {
  return isObject(value) && value.window === value;
}
function getWindow(target) {
  if (target) {
    if (isShadowRoot(target)) {
      return getWindow(target.host);
    }
    if (isDocument(target)) {
      return target.defaultView || window;
    }
    if (isElement(target)) {
      return target.ownerDocument?.defaultView || window;
    }
  }
  return window;
}
function getDocument(target) {
  if (target) {
    if (isWindowLike(target)) {
      return target.document;
    }
    if (isDocument(target)) {
      return target;
    }
    return target.ownerDocument || document;
  }
  return document;
}
function getDocumentElement(target) {
  return getDocument(target).documentElement;
}

// src/format-bytes.ts
function formatBytes(bytes) {
  const units = ["B", "KB", "MB", "GB"];
  let unitIndex = 0;
  let num = bytes;
  while (Math.abs(num) >= 1024 && unitIndex < units.length - 1) {
    num /= 1024;
    unitIndex++;
  }
  const fraction = unitIndex === 0 && num % 1 === 0 ? 0 : 1;
  return `${num.toFixed(fraction)}${units[unitIndex]}`;
}

// src/get-id.ts
var id = 0;
function getId() {
  id = id % Number.MAX_SAFE_INTEGER + 1;
  return id;
}

// src/once.ts
function once(fn) {
  let called = false;
  let result;
  return () => {
    if (!called) {
      result = fn();
      called = true;
      fn = void 0;
    }
    return result;
  };
}
export {
  formatBytes,
  getDocument,
  getDocumentElement,
  getId,
  getWindow,
  isDocument,
  isDocumentFragment,
  isElement,
  isElementLike,
  isHTMLElement,
  isMathMLElement,
  isNodeLike,
  isObject,
  isSVGElement,
  isShadowRoot,
  isTextNode,
  isWindowLike,
  once
};
